import CaseNotesCollapse from './CaseNotesCollapse'

export default CaseNotesCollapse
